
import { Discipline } from './types';

export const literature: Discipline = {
  id: 'literature',
  name: 'Literature',
  courses: [
    {
      id: 'lit101',
      title: 'Old English and Beowulf',
      instructor: 'Arthur Bahr',
      link: 'https://www.youtube.com/playlist?list=PLUl4u3cNGP61XcBw73jdcpNO-pju-mFtw',
      platform: 'youtube',
      thumbnailVideoUrl: 'https://www.youtube.com/watch?v=N61p2aoPPVs&list=PLUl4u3cNGP61XcBw73jdcpNO-pju-mFtw&index=2&t=20s',
      alternateLinks: [
        {
          platform: 'MIT',
          url: 'https://ocw.mit.edu/courses/21l-601j-old-english-and-beowulf-spring-2023/'
        }
      ]
    },
    {
      id: 'lit102',
      title: 'Dante in Translation',
      instructor: 'Giuseppe Mazzotta',
      link: 'https://www.youtube.com/playlist?list=PLD1450DFDA859F694',
      platform: 'youtube',
      thumbnailVideoUrl: 'https://www.youtube.com/watch?v=679FGDpZBew',
      alternateLinks: [
        {
          platform: 'Yale',
          url: 'https://oyc.yale.edu/italian-language-and-literature/ital-310'
        },
        {
          platform: 'Apple Podcasts',
          url: 'https://podcasts.apple.com/us/podcast/dante-in-translation-audio/id341650796'
        }
      ]
    },
    {
      id: 'lit103',
      title: 'Cervantes\' Don Quixote',
      instructor: 'Roberto González Echevarría',
      link: 'https://www.youtube.com/playlist?list=PL4A35EEAEE3880943',
      platform: 'youtube',
      thumbnailVideoUrl: 'https://www.youtube.com/watch?v=P-D0iXLZWO0',
      alternateLinks: [
        {
          platform: 'Yale',
          url: 'https://oyc.yale.edu/spanish-and-portuguese/span-300'
        },
        {
          platform: 'Apple Podcasts',
          url: 'https://podcasts.apple.com/us/podcast/cervantes-don-quixote-audio/id430668512'
        }
      ]
    },
    {
      id: 'lit104',
      title: 'Shakespeare and Politics',
      instructor: 'Paul Cantor',
      link: 'https://www.youtube.com/playlist?list=PLKjJE86mQRtsUKNTj5AmsBqoHkwuJP2kr',
      platform: 'youtube',
      thumbnailVideoUrl: 'https://www.youtube.com/watch?v=0b773Pc1fYs'
    },
    {
      id: 'lit105',
      title: 'Shakespeare After All: The Later Plays',
      instructor: 'Marjorie Garber',
      link: 'https://www.youtube.com/playlist?list=PLLBTlqKLPFAOwyw6tyJdshu-aHOyHA4TN',
      platform: 'youtube',
      thumbnailVideoUrl: 'https://www.youtube.com/watch?v=A0mFFJJLM2M'
    },
    {
      id: 'lit106',
      title: 'Milton',
      instructor: 'John Rogers',
      link: 'https://www.youtube.com/playlist?list=PL2103FD9F9D0615B7',
      platform: 'youtube',
      thumbnailVideoUrl: 'https://www.youtube.com/watch?v=pf91LApkCpU',
      alternateLinks: [
        {
          platform: 'Yale',
          url: 'https://oyc.yale.edu/english/engl-220'
        },
        {
          platform: 'Apple Podcasts',
          url: 'https://podcasts.apple.com/us/podcast/milton-audio/id341652716'
        }
      ]
    },
    {
      id: 'lit107',
      title: 'Modern Poetry',
      instructor: 'Langdon Hammer',
      link: 'https://www.youtube.com/playlist?list=PLh9mgdi4rNewA25FVJ-lawQ-yr-alF58z',
      platform: 'youtube',
      thumbnailVideoUrl: 'https://www.youtube.com/watch?v=aG9el6hOjm8',
      alternateLinks: [
        {
          platform: 'Yale',
          url: 'https://oyc.yale.edu/english/engl-310'
        }
      ]
    },
    {
      id: 'lit108',
      title: 'Hemingway, Fitzgerald, Faulkner',
      instructor: 'Wai Chee Dimock',
      link: 'https://www.youtube.com/playlist?list=PL84C3A4DD9C263D79',
      platform: 'youtube',
      thumbnailVideoUrl: 'https://www.youtube.com/watch?v=0GLy6_gjenA',
      alternateLinks: [
        {
          platform: 'Yale',
          url: 'https://oyc.yale.edu/american-studies/amst-246'
        },
        {
          platform: 'Apple Podcasts',
          url: 'https://podcasts.apple.com/us/podcast/hemingway-fitzgerald-and-faulkner/id515956450'
        }
      ]
    },
    {
      id: 'lit109',
      title: 'The American Novel Since 1945',
      instructor: 'Amy Hungerford',
      link: 'https://www.youtube.com/playlist?list=PLE33BCD966FF96F23',
      platform: 'youtube',
      thumbnailVideoUrl: 'https://www.youtube.com/watch?v=TyVAU5iGe0k',
      alternateLinks: [
        {
          platform: 'Yale',
          url: 'https://oyc.yale.edu/english/engl-291'
        },
        {
          platform: 'Apple Podcasts',
          url: 'https://podcasts.apple.com/us/podcast/the-american-novel-since-1945-audio/id341650250'
        }
      ]
    },
    {
      id: 'lit110',
      title: 'Introduction to Theory of Literature',
      instructor: 'Paul Fry',
      link: 'https://www.youtube.com/playlist?list=PLD00D35CBC75941BD',
      platform: 'youtube',
      thumbnailVideoUrl: 'https://www.youtube.com/watch?v=4YY4CTSQ8nY',
      alternateLinks: [
        {
          platform: 'Yale',
          url: 'https://oyc.yale.edu/english/engl-300'
        },
        {
          platform: 'Apple Podcasts',
          url: 'https://podcasts.apple.com/us/podcast/literary-theory-audio/id341652579'
        }
      ]
    }
  ]
};
